import React from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
import CircularProgress from './tone-step/circular-progress-bar';

var ToneCalibrationIntroStep = function ToneCalibrationIntroStep(_ref) {
  var content = _ref.content,
      onNextClick = _ref.onNextClick;
  return /*#__PURE__*/React.createElement(StepWrapper, {
    backgroundImage: content.BackgroundImage,
    stepClassNames: "step--tone-calibration-intro"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__text"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    icon: content.StepHeaderIcon,
    header: content.StepHeaderTitle
  }), /*#__PURE__*/React.createElement("div", {
    className: "tone-progress"
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    sqSize: 60,
    strokeWidth: 10,
    percentage: 0,
    showPercentage: true
  })), /*#__PURE__*/React.createElement("h2", {
    className: "step__title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "step-circle"
  }, "1"), " ", content.Heading), /*#__PURE__*/React.createElement("p", {
    className: "step__body"
  }, content.Body), /*#__PURE__*/React.createElement("h2", {
    className: "step__title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "step-circle"
  }, "2"), " ", content.Heading2)), /*#__PURE__*/React.createElement("div", {
    className: "step__buttons"
  }, /*#__PURE__*/React.createElement("button", {
    className: "step-button like-orange-button-large",
    onClick: function onClick(e) {
      e.preventDefault();
      onNextClick();
    }
  }, content.NextButtonLabel)));
};

ToneCalibrationIntroStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default ToneCalibrationIntroStep;